import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {UserProfileInfo} from '../models/user/profile-info';
import {tap} from 'rxjs/operators';
import {RegistrationInfo} from '../models/user/registrationInfo';
import {UnverifiedUser} from '../models/user/unverified-user';
import {UserAccount} from '../models/user/user-account';
import {UserAccountConstants} from '../models/user/user-account-constants';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private readonly ACCOUNT_URL = '/api/user/accounts';

  public profilePicture: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
  public userIdForCitizen: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(private readonly http: HttpClient) {
  }

  public getUserProfile(): Observable<UserProfileInfo> {
    return this.http.get<UserProfileInfo>('/api/user/accounts/profile')
      .pipe(
        tap(userProfile =>
          this.profilePicture.next(userProfile.imageSrc)
        )
      );
  }

  public updateUserProfileInfo(userProfileInfo: UserProfileInfo): Observable<UserProfileInfo> {
    return this.http.put<UserProfileInfo>('/api/user/accounts/edit-profile', userProfileInfo);
  }

  public citizenRegister(account: RegistrationInfo): Observable<number> {
    return this.http.put<number>('/api/users/register-citizen', account);
  }

  public fetchDataForUnverifiedUser(): Observable<UnverifiedUser> {
    return this.http.get<UnverifiedUser>('/api/users/unverified/pre-populate-data');
  }

  public verifyMail(code: string): Observable<any> {
    return this.http.get<any>(`/api/users/citizen/verify-mail/${code}`);
  }

  public resendMail(): Observable<void> {
    return this.http.get<void>(`/api/users/citizen/send-mail/${this.userIdForCitizen.value}`);
  }

  public getAccounts(): Observable<UserAccount[]> {
    return this.http.get<UserAccount[]>(this.ACCOUNT_URL);
  }

  public migrateAccount(userIdToMigrate: number): Observable<void> {
    return this.http.post<void>(this.ACCOUNT_URL + `/migrate-account/${userIdToMigrate}`, null);
  }

  public getAccountConstants(): Observable<UserAccountConstants> {
    return this.http.get<UserAccountConstants>(this.ACCOUNT_URL + '/constants');
  }

  public getCurrentAccount(): Observable<UserAccount> {
    return this.http.get<UserAccount>(this.ACCOUNT_URL + '/current');
  }

  public upsertCurrentAccount(userAccount: UserAccount): Observable<UserAccount> {
    return this.http.put<UserAccount>(this.ACCOUNT_URL + '/current/upsert', userAccount);
  }

}
